import React from 'react';

interface Props {
	title: string;
}
export function PodGridItemHeader(props: React.PropsWithChildren<Props>) {

	return (
		<div className='pods-benefits-grid-item-header'>
			<h3 className='pods-benefits-grid-item-title'>{props?.title}</h3>
			{props.children}
		</div>
	);
}